module.exports = __webpack_public_path__ + "static/media/WEBnegro_08.f4c4bc23.png";